var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReportIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 16H2V2H11V0H2C0.9 0 0 0.9 0 2V16C0 17.1 0.9 18 2 18H16C17.1 18 18 17.1 18 16V7H16V16Z",
    fill: "#6B62D1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 10H12V14H14V10Z",
    fill: "#6B62D1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 7H4V14H6V7Z",
    fill: "#6B62D1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10 4H8V14H10V4Z",
    fill: "#6B62D1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16 2V0H14V2H12V4H14V6H16V4H18V2H16Z",
    fill: "#6B62D1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportIcon);
export default __webpack_public_path__ + "static/media/report_icon.dffcce38.svg";
export { ForwardRef as ReactComponent };